export default "__VITE_ASSET__DkklNNx9__"